import React from 'react'
import SplitText from "../../../common/SplitText";

export default function Works() {
    return (
        <div className='relative mt-[100px]'>
            <div className='flex justify-center'>
                <SplitText
                    text="How It Works"
                    tag="h2"
                    className='text-[#181F38] text-[30px] sm:text-[52px] font-bold text-center'
                    delay={30}
                    duration={0.6}
                    ease="power3.out"
                    splitType="words, chars"
                    from={{ opacity: 0, y: 30 }}
                    to={{ opacity: 1, y: 0 }}
                    threshold={0.1}
                    rootMargin="-40px"
                    textAlign="center"
                />
            </div>
            
            <div className='mt-[36px] sm:mt-[54px] flex flex-col gap-[20px] sm:gap-[24px] w-11/12 max-w-[900px] mx-auto'>
                
                <div className='p-[20px] sm:p-[28px] bg-white rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex gap-[18px] sm:gap-[28px] items-center'>
                    <div className='relative size-[48px] sm:size-[64px] flex justify-center items-center shrink-0 rounded-[20px] bg-[#FFDAD8] text-[#D94F48] font-extrabold text-[20px] sm:text-[24px] shadow-sm'>
                        01
                    </div>
                    <div>
                        <h3 className='text-[#181F38] text-[18px] sm:text-[22px] font-bold'>Step 1: Choose Your Model</h3>
                        <p className='mt-[4px] text-[#475569] text-[14px] sm:text-[16px] font-normal leading-relaxed'>Select the cart model (Economy, Mid-Range, or Premium) that fits your investment and location.</p>
                    </div>
                </div>

                <div className='p-[20px] sm:p-[28px] bg-white rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex gap-[18px] sm:gap-[28px] items-center'>
                    <div className='relative size-[48px] sm:size-[64px] flex justify-center items-center shrink-0 rounded-[20px] bg-[#FFEED4] text-[#D9822B] font-extrabold text-[20px] sm:text-[24px] shadow-sm'>
                        02
                    </div>
                    <div>
                        <h3 className='text-[#181F38] text-[18px] sm:text-[22px] font-bold'>Step 2: Agreement & Training</h3>
                        <p className='mt-[4px] text-[#475569] text-[14px] sm:text-[16px] font-normal leading-relaxed'>Sign the franchise agreement, secure your protected territory, and attend comprehensive operations training.</p>
                    </div>
                </div>

                <div className='p-[20px] sm:p-[28px] bg-white rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex gap-[18px] sm:gap-[28px] items-center'>
                    <div className='relative size-[48px] sm:size-[64px] flex justify-center items-center shrink-0 rounded-[20px] bg-[#FFF6D4] text-[#C49B1A] font-extrabold text-[20px] sm:text-[24px] shadow-sm'>
                        03
                    </div>
                    <div>
                        <h3 className='text-[#181F38] text-[18px] sm:text-[22px] font-bold'>Step 3: Launch Business</h3>
                        <p className='mt-[4px] text-[#475569] text-[14px] sm:text-[16px] font-normal leading-relaxed'>Receive your fully equipped mobile cart, inventory stock, and marketing materials for a smooth grand opening.</p>
                    </div>
                </div>

                <div className='p-[20px] sm:p-[28px] bg-white rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex gap-[18px] sm:gap-[28px] items-center'>
                    <div className='relative size-[48px] sm:size-[64px] flex justify-center items-center shrink-0 rounded-[20px] bg-[#E0FFE8] text-[#1E9E49] font-extrabold text-[20px] sm:text-[24px] shadow-sm'>
                        04
                    </div>
                    <div>
                        <h3 className='text-[#181F38] text-[18px] sm:text-[22px] font-bold'>Step 4: Earn & Scale</h3>
                        <p className='mt-[4px] text-[#475569] text-[14px] sm:text-[16px] font-normal leading-relaxed'>Start selling delicious fresh kulfi, building loyal customers while benefiting from ongoing supply and marketing support.</p>
                    </div>
                </div>

            </div>
        </div>
    )
}
